"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.white = exports.grLight = exports.gr = exports.black = void 0;
var _styledComponents = require("styled-components");
var AccordionStyled = _interopRequireWildcard(require("../AccordionDrawer/index.styled"));
var LinkStyles = _interopRequireWildcard(require("../Link/index.styled"));
const black = exports.black = (0, _styledComponents.css)`
  background: #000;
  color: #fff;
  ${AccordionStyled.DrawerHeading},
  ${AccordionStyled.DrawerIcon},
  ${AccordionStyled.DrawerButton},
  ${AccordionStyled.DrawerContent},
  ${AccordionStyled.AccordionTitleText},
  ${LinkStyles.Anchor},
  ${LinkStyles.Button},
  ${AccordionStyled.AccordionDrawer}{
    color: #fff;
  }
`;
const white = exports.white = (0, _styledComponents.css)`
  background: #fff;
  color: #000;
  ${AccordionStyled.DrawerHeading},
  ${AccordionStyled.DrawerIcon},
  ${AccordionStyled.DrawerButton},
  ${AccordionStyled.DrawerContent},
  ${AccordionStyled.AccordionTitleText},
  ${LinkStyles.Anchor},
  ${LinkStyles.Button},
  ${AccordionStyled.AccordionDrawer}{
    color: #000;
  }
`;
const gr = exports.gr = (0, _styledComponents.css)`
  background: #000;
  color: #FFF;
  ${AccordionStyled.DrawerHeading},
  ${AccordionStyled.DrawerIcon},
  ${AccordionStyled.DrawerButton},
  ${AccordionStyled.DrawerContent},
  ${AccordionStyled.AccordionTitleText},
  ${LinkStyles.Anchor},
  ${LinkStyles.Button},
  ${AccordionStyled.AccordionDrawer}{
    color: #FFF;
  }
  h1, h2, h3, h4, h5, h6 {
    color: #E60010;
  }
`;
const grLight = exports.grLight = (0, _styledComponents.css)`
  background: #FFF;
  color: #000;
  ${AccordionStyled.DrawerHeading},
  ${AccordionStyled.DrawerIcon},
  ${AccordionStyled.DrawerButton},
  ${AccordionStyled.DrawerContent},
  ${AccordionStyled.AccordionTitleText},
  ${LinkStyles.Anchor},
  ${LinkStyles.Button},
  ${AccordionStyled.AccordionDrawer}{
    color: #000;
  }
  h1, h2, h3, h4, h5, h6 {
    color: #E60010;
  }
`;